import React, { useState, useEffect, useContext, useMemo } from "react";
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SidebarMenuList from "./SidebarMenuList";
import Stack from "@mui/material/Stack";
import { ReactComponent as NextLogo } from '../../common/images/nextBrand.svg';
import { Context } from "../../../common/context/Context";

const drawerWidth = 250;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            backgroundColor: '#293042',
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            /**on closed state following css will apply*/
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: 0,
                [theme.breakpoints.up('sm')]: {
                    width: 0
                },
            }),
        },
    }),
);

const Sidebar = ({ open, setOpen }) => {
    const context= useContext(Context);
    

    const fetchNextLogoUrl = (key) => {
        if (context?.adminNavigationCmsData?.Components && context?.adminNavigationCmsData?.Components["Header"]) {
          const mediaList = context?.adminNavigationCmsData?.Components["Header"] || [];
          return mediaList?.MediaList.find((x) => x.Key === key)?.SmallImage?.ImageUrl || '';
        }
        return '';
      }
      const nextLogoUrl=useMemo(()=>fetchNextLogoUrl('Header.HeaderLogo'),[context?.adminNavigationCmsData?.Components]);

    return (
        <Drawer
            variant="permanent"
            open={open}
        >
            <Toolbar
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    backgroundColor: '#f7f9fc'
                }}
            >
                <Stack>
                    {/* <NextLogo height={40} alt="Next Logo" /> */}
                    <img src={nextLogoUrl} height={40} alt="Next Logo" />
                </Stack>

                <IconButton onClick={() => setOpen(!open)}>
                    <ChevronLeftIcon />
                </IconButton>

            </Toolbar>
            <Divider />
            <List component="nav" sx={{ maxHeight: 700, overflow: 'auto' }}>
                {/**sidebar menu rendering */}
                <SidebarMenuList />
                {/* <Divider sx={{ my: 1 }} /> */}
            </List>
        </Drawer>
    )

}
export default Sidebar